import { useEffect, useRef } from 'react';
import { getLiveLayoutColors } from './helper/presentationLive';
import InteractionTooltip from '@molecules/InteractionTooltip';
import Tooltip from '@atoms/new/tooltip';
import SlideImage from '@components/Presentation/main/Sidebar/SlideImage';
import { ImageIcon } from '@phosphor-icons/react';

const InteractionsList = ({
  questionIds,
  interactions,
  handleLinkFeature,
  currentRosFeature,
  moderationMode = false,
  layoutTheme = 'dark',
  isDisabled = false
}) => {
  const ref = useRef();
  const colors = getLiveLayoutColors(layoutTheme);

  const getBoxClass = (featureId) => {
    if (moderationMode) {
      return `w-12 h-12 rounded-full flex justify-center items-center ${currentRosFeature?.id === featureId ? 'bg-grey-50' : 'bg-primary-500 text-white'}`;
    }
    return `h-12 w-12 rounded-full flex justify-center items-center ${currentRosFeature?.id === featureId ? colors.boxColor : `bg-transparent ${colors.hoverBg}`}`;
  };

  const getSvgColor = (featureId) => {
    if (currentRosFeature?.id === featureId) {
      return colors.svgActiveColorHex;
    }

    if (questionIds) {
      return colors.svgColorHex;
    }

    return '#111827';
  };

  useEffect(() => {
    const listDiv = document.getElementById('interactionList');
    if (!listDiv) {
      return;
    }

    const currentElement = document.querySelector(`[data-list-id="${currentRosFeature?.id}"]`);
    if (!currentElement) {
      return;
    }

    const containerHeight = listDiv.clientHeight;
    const interactionHeight = 50;
    const visibleInteractions = Math.floor(containerHeight / interactionHeight);
    const middleIndex = Math.floor(visibleInteractions / 2);
    const interactions = Array.from(listDiv.children);
    const currentIndex = interactions.indexOf(currentElement);

    const totalHeight = interactions.length * interactionHeight;
    const maxScrollTop = totalHeight - containerHeight;

    let newScrollTop = (currentIndex - middleIndex) * interactionHeight;
    newScrollTop = Math.max(0, Math.min(newScrollTop, maxScrollTop));

    listDiv.scrollTop = newScrollTop;
  }, [currentRosFeature?.id, interactions.length]);

  return interactions.length > 0 && <div
    ref={ref}
    id='listDiv'
    className={`${colors.containerColor} ${isDisabled ? 'opacity-50' : ''} flex shrink-0 items-center gap-y-2 flex-col interactions-list w-full rounded-full overflow-hidden p-[2px]`}>

    <div id="interactionList" className={'items-center flex flex-col gap-y-2 overflow-y-auto hide-scrollbar'}>
      {interactions.map((interaction, index) => {
        const interactionId = interaction.id;
        return (
          <div
            key={interactionId}
            id={interactionId}
            data-list-id={interactionId}
          >
            <Tooltip
              key={`tooltip-${interactionId}`}
              content={<InteractionTooltip key={`tooltip-content-${interactionId}`} interaction={interaction} />}
              placement="left"
              isDisabled={isDisabled}
            >
              <div
                className={`${getBoxClass(interactionId)} ${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                onClick={!isDisabled ? (currentRosFeature?.id === interactionId ? () => { } :
                  () => {
                    handleLinkFeature(interaction, index, true);
                  }) : undefined}
              >
                {interaction?.type === 'PDF Slide' ? (
                  <ImageIcon key={`icon-${interactionId}`} style={{
                    color: isDisabled ? (layoutTheme === 'dark' ? '#6B7280' : '#9CA3AF') : getSvgColor(interactionId),
                    width: 24,
                    height: 24
                  }} />
                ) : (
                  <SlideImage
                    key={`slide-${interactionId}`}
                    slideType={interaction.type}
                    color={isDisabled ? (layoutTheme === 'dark' ? '#6B7280' : '#9CA3AF') : getSvgColor(interactionId)}
                    svgWidth="24"
                    svgHeight="24"
                    roundedClassName="rounded-full"
                  />
                )}
              </div>
            </Tooltip>
          </div>
        );
      })}
    </div>
  </div >;
};

export default InteractionsList;
